import React, { useState, useEffect } from 'react';
import { Navigate } from '@tanstack/react-router';
import { get } from '../api';
import AiStudioPaywall from '../components/AiStudioPaywall';

export default function AiStudioPage() {
  const [loading, setLoading] = useState(true);
  const [isSubscribed, setIsSubscribed] = useState(false);

  useEffect(() => {
    const init = async () => {
      try {
        // Check subscription status
        const usageData = await get('/api/1/user/usage');
        setIsSubscribed(usageData.has_active_subscription);
      } catch (error) {
        console.error("Failed to fetch data", error);
      } finally {
        setLoading(false);
      }
    };
    init();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-full bg-background">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-500 shadow-[0_0_15px_rgba(168,85,247,0.5)]"></div>
      </div>
    );
  }

  if (!isSubscribed) {
    return <AiStudioPaywall />;
  }

  return <Navigate to="/app/ai-studio/create" />;
}
